import * as posPaymentMethods from "../lib/api/paymentMethods";
import * as routeHelpers from "../lib/routeHelpers";
import * as Sentry from "@sentry/capacitor";
import describeNetworkError from "../lib/describeNetworkError";
import ErrorModal from "./ErrorModal";
import logger from "../lib/sentryLogger";
import OpenRegisterDrawer from "./OpenRegisterDrawer";
import React, {useState, useContext} from "react";
import {StationContext} from "./StationContext";
import {useNavigate} from "react-router-dom";
import {openCashDrawer} from "../lib/CashDrawer/CashDrawerPlugin";

const strings = {
    cashDrawerError:
        "An unexpected error occurred when establishing a connection with the cash drawer.",
    cashDrawerErrorWithMessage: (errMessage: string) =>
        `There was an error related to the cash drawer: ${errMessage}`,
};

export default function ManagerNoSale() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const {cashierMode, setCashierMode, isTraining} =
        useContext(StationContext);

    function onClose() {
        navigate(routeHelpers.managerMenu());
    }

    function onOpenRegister() {
        if (isLoading) {
            return;
        }

        logger.info("Accessing manager no sale screen");
        if (cashierMode.type !== "manager") {
            logger.warn(
                "Accessing manager no sale screen when not in manager mode",
            );
            return;
        }

        setIsLoading(true);
        posPaymentMethods
            .noSale(cashierMode.managerId)
            .then(() => openCashDrawer(isTraining))
            .then(() => {
                setIsLoading(false);
                navigate(routeHelpers.menu());
                setCashierMode({type: "user"});
            })
            .catch((err) => {
                let errMsg = "";
                if (!err.config) {
                    // not a axios error, produced by cash drawer call.
                    if (err.message) {
                        errMsg = strings.cashDrawerErrorWithMessage(
                            err.message,
                        );
                    } else {
                        errMsg = strings.cashDrawerError;
                    }
                    setErrorMessage(errMsg);
                    Sentry.captureMessage(errMsg);
                } else {
                    errMsg = describeNetworkError(err).join("\n");
                    logger.warn(
                        "Failed to make POST /payment-methods/no-sale call.",
                        {
                            errorMessage: errMsg,
                        },
                    );
                }
                setErrorMessage(errMsg);
                setIsLoading(false);
            });
    }

    return (
        <>
            <OpenRegisterDrawer
                onClose={onClose}
                onOpenRegister={onOpenRegister}
                loading={isLoading}
            />
            {errorMessage ? (
                <ErrorModal
                    onClose={() => setErrorMessage("")}
                    errorMessage={errorMessage}
                    showITInfo
                />
            ) : null}
        </>
    );
}
